module.exports = __webpack_public_path__ + "static/media/0224_IMG_LE_SOL_MEGALITH_MEGABLACK.8cb63d43.png";